<template>
  <div id="user-list">
    <v-card>
      <v-card-title> {{ $t("Keskustelukanavat") }} </v-card-title>
      <!-- actions -->

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn color="primary" class="mb-4" :to="{ name: 'admin-chat-channel-form' }">
            <span>{{ $t("Uusi kanava") }}</span>
          </v-btn>
        </div>
      </v-card-text>
      <v-data-table :headers="tableColumns" :items="channels" :server-items-length="totalCount" :items-per-page="1000"
        :options.sync="options" :loading="loading" mobile-breakpoint="0" hide-default-footer>
        <template #[`item.name`]="{ item }">
          <div class="d-flex align-center">
            <router-link :to="{ name: 'admin-chat-channel-form', params: { id: item.id } }"
              class="font-weight-medium text-decoration-none">
              {{ item.name }}
            </router-link>
          </div>
        </template>

        <template #[`item.group`]="{ item }">
          <v-chip label color="primary" small>
            {{ item.group }}
          </v-chip>
        </template>

        <template #[`item.description`]="{ item }">
          <span>{{ item.description }}</span>
        </template>

        <template #[`item.active`]="{ item }">
          <div>
            <v-icon v-if="item.is_active" size="24" color="success">{{ icons.mdiCheckboxMarkedCircle }}
            </v-icon>
            <v-icon v-else size="24" color="error">{{ icons.mdiCloseCircle }}
            </v-icon>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>


<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import adminApi from "@/api/admin";
import { mdiCheckboxMarkedCircle, mdiCloseCircle, mdiPlus } from "@mdi/js";
import { useTranslations } from "@core/libs/i18n";

export default {
  setup() {
    const channels = ref([]);
    const totalCount = ref(0);

    const options = ref({});
    const loading = ref(false);

    const { t } = useTranslations();

    const tableColumns = [
      { text: t("Otsikko").toUpperCase(), value: "name", sortable: false, width: 240 },
      { text: t("Ryhmä").toUpperCase(), value: "group", sortable: false },
      {
        text: t("Kuvaus").toUpperCase(),
        value: "description",
        sortable: false,
      },
      {
        text: t("Aktiivinen").toUpperCase(),
        value: "active",
        sortable: false,
      },
    ];

    // fetch data
    const fetchChannels = async () => {
      loading.value = true;
      const response = await adminApi.getChannels();

      channels.value = response.data;
      totalCount.value = channels.value.length;

      loading.value = false;
    };

    // UnRegister on leave
    onMounted(() => {
      fetchChannels();
    });

    return {
      channels,
      totalCount,
      tableColumns,
      options,
      loading,
      icons: {
        mdiCheckboxMarkedCircle,
        mdiCloseCircle,
        mdiPlus,
      },
    };
  },
};
</script>

<style></style>
